<template>
    <div class="fhv-centent">
        <h4 class="title-topic">Update Software</h4>
        <span class="step-des" v-for="(item,index) in list" :key="index" v-html="item.content"></span>
        <el-upload
            ref="upload"
            action="/boafrm/formUpload"
            :file-list="fileList"
            :on-success="updateSuccess"
            accept=".bin"
            :limit="1"
            :multiple="false"
            :before-upload="checkFile"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            :auto-upload="false">
            <p>
                Select File Name:
                <el-button slot="trigger" size="small" type="info" :disabled="$G_DEVICE_CFG.isReadOnly"> Browse... </el-button>
            </p>                
        </el-upload>
        <hr>
        <el-button  size="small" type="primary" @click="submitUpload" :disabled="$G_DEVICE_CFG.isReadOnly"> Update Software</el-button>
    </div>
</template>

<script>
import Reboot from '@/components/reboot.js'
export default {
    data(){
        return {
            fileList: [],
            list:[
                {"content":"Step 1: Obtain an updated software image file from your ISP.</br>"},
                {"content":"Step 2: Enter the path to the image file location in the box below or click the 'Browse' button to locate the image file.</br>" },
                {"content":"Step 3: Click the 'Update Software' button once to upload the new image file.</br>"},
                {"content":"Note: The update process takes about 2 minutes to complete, and your Broadband Router will reboot.</br>"},
            ]
        }
    },
    methods:{
        submitUpload() {
            this.$refs.upload.submit();
        },
        updateSuccess(response, file, fileList){
            Reboot.updata(this,"The file was uploaded successfully! The device is restarting please wait...")
        },
        checkFile(file){
            if(!file.name.match(/.bin/))
            {
                this.$message.error("Wrong file type, please select again!")
                return false
            }  
        },
    }
}
</script>
<style lang="scss" >

.fhv-centent{
    .step-des{
        display: block;
        margin-bottom:10px;
        font-size: 13px;
        font-family: 'db_helvethaicaais_x55_regular';
    }
    
    .el-upload__input{
        display: none!important;
    }
}
</style>



